import SubscriptionEndsBanner from "common/Home/Banners/SubscriptionEndsBanner";
import { BannerWrapper } from "common/Banner/Banner";
import React from "react";
import styled from "styled-components";
import { AuthUser } from "@shared/types";
import MobileAppBanner from "common/Home/Banners/MobileAppBanner";
import { isMobile } from "react-device-detect";
import SubscriptionExpiredBanner from "common/Home/Banners/SubscriptionExpiredBanner";
import { IS_TELEGRAM_WEB_APP } from "common/constants";
import TelegramWebAppBanner from "common/Home/Banners/TelegramWebAppBanner";
import StyledBanner from "common/Home/Banners/StyledBanner";
import DemoModeBanner from "common/Home/Banners/DemoModeBanner";
import FreemiumBanner from "common/Home/Banners/FreemiumBanner";

interface BannersProps {
  user: AuthUser;
}

const Banners = ({ user }: BannersProps) => {
  const showMobileAppBanner =
    !IS_TELEGRAM_WEB_APP && isMobile && !user.is_admin && !user.isExpired();

  let subscriptionBanner: React.JSX.Element;
  if (user.isExpired()) {
    subscriptionBanner = <SubscriptionExpiredBanner user={user} />;
  } else {
    subscriptionBanner = <SubscriptionEndsBanner user={user} />;
  }

  return (
    <Wrapper>
      <StyledBanner />
      <FreemiumBanner />
      <DemoModeBanner />
      {showMobileAppBanner && <MobileAppBanner />}
      {IS_TELEGRAM_WEB_APP && !isMobile && <TelegramWebAppBanner />}
      {subscriptionBanner}
    </Wrapper>
  );
};

export default Banners;

const Wrapper = styled.div`
  ${BannerWrapper} {
    &:not(:last-of-type) {
      border-bottom: ${(p) => p.theme.borders.medium};
    }
  }
`;
